import client from '@config/client'
import API_URL from '@config/services'
import {
  ApiClientResult,
  ApiClientResponse,
  TaskList,
  TaskListPayload
} from '@/types/api'
import { ID } from '../types'

interface ListPayload {
  name: string
  description?: string
  project_id?: number | string
  color?: string
  [key: string]: any
}

/**
 * Creates a new task list
 * @param payload - List data
 * @returns API response
 */
export const onCreateList = (
  payload: ListPayload = {} as ListPayload
): Promise<ApiClientResult> =>
  client
    .post(API_URL.TASKS.GET_TASKS_LISTS_LIST(), payload)
    .then(response => response)
    .catch(error => error.response)

/**
 * Updates a task list
 * @param listId - List ID
 * @param payload - List data to update
 * @returns API response
 */
export const onEditList = (
  listId: number | string,
  payload: Partial<ListPayload> = {}
): Promise<ApiClientResult> =>
  client
    .patch(`${API_URL.TASKS.GET_TASKS_LISTS_LIST()}${listId}`, payload)
    .then(response => response)
    .catch(error => error.response)

/**
 * Deletes a task list
 * @param listId - List ID
 * @returns API response
 */
export const onDeleteList = (
  listId: number | string
): Promise<ApiClientResult> =>
  client
    .delete(`/tasks/lists/${listId}/`)
    .then(response => response)
    .catch(error => error.response)
